import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import AppContext from '../../../contexts/AppContext';
import { isMobile, isTablet } from 'react-device-detect';
import './IntroLayer.css';
import IntroStart from './IntroStart';
import IntroDescr from './IntroDescr';
import { CircularProgress } from '@material-ui/core';

function ButtonComponent(props) {
  const { onClick, loading } = props;
  return (
    <Button
      size="small"
      color="primary"
      variant="contained"
      onClick={onClick}
      disabled={loading}
      className={props.classes.btn}
      classes={{ root: props.classes.rootBtn }}
    >
      {loading && <CircularProgress color="secondary" size={14} />}
      {!loading && props.txt}
    </Button>
  );
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    '-webkit-text-stroke-width': '0.2px',
    '-webkit-text-stroke-color': 'white',
  },
  paper: {
    backgroundColor: 'rgba(255,255,255,0)',
    padding: theme.spacing(2, 4, 3),
    borderRadius: '20px',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    color: 'white',
    outline: 'none',
    maxWidth: '1000px',
  },
  rootBtn: {
    background: 'linear-gradient(45deg, #5B92E5 30%, #5B92E5 90%)',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 48,
    padding: '0 30px',
    boxShadow: '0 3px 5px 2px rgba(120, 120, 120, .3)',
  },
  btn: {},
}));

export default function IntroLayer(props) {
  const {
    currentLocation,
    loadedGallery,
    onEndIntroHandler,
    isAppReady,
    isAppAxlStarted,
    isSharedDefault,
  } = props;

  const { dictionnary } = useContext(AppContext);
  const classes = useStyles();

  const isWaitingForGalleryData = () => {
    return !loadedGallery || (!loadedGallery.default && !currentLocation);
  };

  const isReadyForTimer = () => {
    return isAppAxlStarted && isAppReady;
  };

  const [open, setOpen] = React.useState(true);
  const [step, setStep] = React.useState('start');
  const [empty, setEmpty] = React.useState(!isWaitingForGalleryData());

  React.useEffect(() => {
    setEmpty(!isWaitingForGalleryData());

    if (isReadyForTimer() && open) {
      setTimeout(() => {
        setOpen(false);
        onEndIntroHandler();
      }, 4000);
    }
  });

  if (!empty) {
    //console.log('this is empty..');
    return <></>;
  }

  let btnText =
    !loadedGallery || loadedGallery.default
      ? dictionnary.get('intro-btn-start')
      : dictionnary.get('intro-btn-enter');

  if (step === 'descr') {
    btnText = dictionnary.get('intro-btn-create');
  }
  if (isMobile || isTablet) {
    btnText = dictionnary.get('intro-btn-enter');
  }

  return (
    <div>
      <Modal
        aria-labelledby="intro-logo-title"
        aria-describedby="intro-logo-description"
        className={classes.modal}
        open={open}
        closeAfterTransition
        disableAutoFocus
        disableEnforceFocus
      >
        <Fade in={open}>
          <div className={classes.paper}>
            {step === 'start' && (
              <IntroStart
                isSharedDefault={isSharedDefault}
                loading={!isAppReady}
                currentLocation={currentLocation}
                loadedGallery={loadedGallery}
              ></IntroStart>
            )}
            {step === 'descr' && (
              <IntroDescr
                currentLocation={currentLocation}
                loadedGallery={loadedGallery}
              ></IntroDescr>
            )}
            <br />

            {false && (
              <ButtonComponent
                onClick={() => {
                  setOpen(false);
                  onEndIntroHandler();
                  return;

                  /*
                if (
                  (loadedGallery && !loadedGallery.default) ||
                  isMobile ||
                  isTablet
                ) {
                  setOpen(false);
                  onEndIntroHandler();
                  return;
                }
                if (step === 'start') {
                  onClickHandler();
                  setStep('descr');
                } else {
                  setOpen(false);
                  onEndIntroHandler();
                }
                */
                }}
                classes={classes}
                loading={!isAppReady}
                txt={btnText}
              ></ButtonComponent>
            )}

            <div id="logo-container">
              <img
                id="intro-logo"
                src={'street-gallery/assets/icons/UN75_white_E.png'}
              ></img>
              <img
                id="intro-gac-logo"
                src={
                  'street-gallery/assets/icons/logo_lockup_arts___culture_icon_vertical_light.svg'
                }
              ></img>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
